<template>
  <div class="wrap">
    <PayHead :mainTitle="pc_lang.Initialize_payment_password"/>
    <div class="wrapContent">
      <el-form :model="payForm" :rules="payRules" ref="payForm" label-width="0" class="payForm">
        <el-form-item prop="payPassword">
          <p>{{pc_lang.Set_up_payment_password}}</p>
          <el-input type="password" v-model="payForm.payPassword" size="medium" autocomplete="off" @keyup.13.native="regForm('payForm')"></el-input>
        </el-form-item>
        <el-form-item prop="checkPayPassword">
          <p>{{pc_lang.Confirm_payment_password}}</p>
          <el-input type="password" v-model="payForm.checkPayPassword" size="medium" autocomplete="off" @keyup.13.native="regForm('payForm')"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" class="submit" size="medium" @click="regForm('payForm')">{{pc_lang.Confirm2}}</el-button>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import PayHead from '@/components/PayHead'
import * as API_USER from '@/api/user'
import * as RegExp from '@/utils/RegExp'

export default {
  name: 'initPayPassword',
  components: {
    PayHead
  },
  computed: {
    ...mapGetters(['user'])
  },
  data() {
    var validatePay = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Enter_the_password));
      } else if( !RegExp.payword.test(value) ) {
        callback(new Error(this.pc_lang.Password_consists_of_6_digits));
      }else {
        if (this.payForm.checkPayPassword !== '') {
          this.$refs.payForm.validateField('checkPayPassword');
        }
        callback();
      }
    };
    var validatePay2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.pc_lang.Please_enter_the_password_again));
      } else if (value !== this.payForm.payPassword) {
        callback(new Error(this.pc_lang.The_passwords_entered_twice_are_inconsistent));
      } else {
        callback();
      }
    };
    return {
      // 账号表单
      payForm: {
        payPassword: '',
        checkPayPassword: '',
      },
      payRules: {
        payPassword: [
          { validator: validatePay, trigger: 'blur' }
        ],
        checkPayPassword: [
          { validator: validatePay2, trigger: 'blur' }
        ]
      },
      /* 是否需要会跳页面 */
      forward: ''
    }
  },
  async mounted() {

  },
  created() {
    this.forward = this.forward == undefined ? '' : this.$route.query.forward
    if (!!this.user.pay_password) {
      this.$router.push({ name: 'Riches' })
    }
  },
  methods: {
    /* 重置表单 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        }else{
          return false
        }
      })
    },
    submit() {
      let params = {
        password: md5(this.payForm.payPassword)
      }
      API_USER.initPassword(params).then(async res=> {
        let resetData = JSON.parse(JSON.stringify(this.user))
        resetData.pay_password = 1
        await this.$store.dispatch('user', resetData)
        if (!!this.forward) {
          this.$router.push({path: this.forward})
        } else {
          this.$router.push({path: '/riches'})
        }
        this.$message.success(this.pc_lang.Set_up_successfully)
      },rej=> {
        this.$messageBox.alert(rej.msg, 'Error', {
          type: 'error',
          callback: () => {
            this.$router.push({path: '/riches'})
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.wrapContent{
  background: #fff;
  margin: 20px auto 40px;
  padding: 20px 40px;
  .submit{
    margin-top: 20px;
  }
  ::v-deep .payForm{
    .el-input,.el-select{
      width: 450px;
    }
    .el-form-item{
      margin-bottom: 20px;
    }
  }
}
</style>